
const baseDomain = 'https://chtc.force.com/vivreenville/services/apexrest'
export const confiUrl = {
  GET_TOKEN_URL: baseDomain + '/vivreenville/token',
  GET_MY_RENTS_URL: baseDomain + '/vivreenville/getMyRents/',
  RENTS_URL: baseDomain + '/vivreenville/',
}

export const getTokenResults = {
  SUCCESS_VALID_TOKEN_FOUND_EMAIL_SENT: 'SUCCESS_VALID_TOKEN_FOUND_EMAIL_SENT',
  SUCCESS_NEW_TOKEN_EMAIL_SENT: 'SUCCESS_NEW_TOKEN_EMAIL_SENT',
}